export default __webpack_public_path__ + "static/spiritual-maya-hotel-3-a9d7ea3c27e7d7649c3b03d54f39fa20.jpg";